import { render } from "./borough.vue?vue&type=template&id=1c3f7e21&scoped=true"
import script from "./borough.vue?vue&type=script&lang=js"
export * from "./borough.vue?vue&type=script&lang=js"

import "./borough.vue?vue&type=style&index=0&id=1c3f7e21&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3f7e21"]])

export default __exports__